module.exports = __webpack_public_path__ + "img/t3.3899e9df.jpg";